export const toNio = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('es-NI', {
    style: 'currency',
    currency: 'NIO',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toUSD = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toGTQ = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-GT', {
    style: 'currency',
    currency: 'GTQ',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toGBP = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toEUR = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toAUD = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toCAD = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toDKK = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('da-DK', {
    style: 'currency',
    currency: 'DKK',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toAED = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('ar-AE', {
    style: 'currency',
    currency: 'AED',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toCHF = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toNOK = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toNZD = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toPLN = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toCZK = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toRON = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toSGD = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: 'SGD',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toSEK = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    currencyDisplay: 'code',
  })
  return formatter.format(value)
}

export const toGTQSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-GT', {
    style: 'currency',
    currency: 'GTQ',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toGBPSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'G',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toNioSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('es-NI', {
    style: 'currency',
    currency: 'NIO',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toUSDSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toEURSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toAUDSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

export const toCADSimpleFormat = (value) => {
  if (!value) {
    return 0
  }

  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(value)
}

// Repite el mismo patrón para los demás:
export const toDKKSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('da-DK', {
    style: 'currency',
    currency: 'DKK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toAEDSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('ar-AE', {
    style: 'currency',
    currency: 'AED',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toCHFSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toNOKSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toNZDSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toPLNSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toCZKSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toRONSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toSGDSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: 'SGD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toSEKSimpleFormat = (value) => {
  if (!value) return 0
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const toCurrencyFormat = (value) => {
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: 2,
  }).format(value)
}
